import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const RefundPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-black text-white">
            <div className="max-w-4xl mx-auto px-6 py-12">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-gray-400 hover:text-purple-400 transition-colors mb-8"
                >
                    <ArrowLeft size={20} />
                    Back
                </button>

                <h1 className="text-4xl font-bold mb-8">Refund Policy</h1>

                <div className="space-y-8 text-gray-300">
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">No Refund Policy</h2>
                        <p className="mb-4">
                            Papers with Graph does not offer refunds for our subscription services. All purchases are final and non-refundable.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">Subscription Cancellation</h2>
                        <p className="mb-4">While we don't provide refunds, you can:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Cancel your subscription at any time</li>
                            <li>Continue to access the service until the end of your current billing period</li>
                            <li>Not be charged for any future billing periods after cancellation</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">Exceptional Circumstances</h2>
                        <p>
                            In cases of technical issues where our service was completely unavailable for an extended period,
                            we may consider compensation in the form of service extension rather than monetary refunds.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
                        <p>
                            If you have any questions about our refund policy, please contact us at{' '}
                            <a href="mailto:billing@paperswithgraph.com" className="text-purple-400 hover:text-purple-300">
                                billing@paperswithgraph.com
                            </a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy; 